import '/@admin:css/views/auth/register.css'

import { Vue } from 'vue-class-component'

import Application from '/@admin/shared/application'

import { http } from '../plugins/http'

class AuthRegister extends Vue {
  private disk: string = _state.disk || ''
  private inputType: 'text' | 'password' = 'password'

  private get disks() {
    return _state.disks
  }

  private get isPasswordVisible() {
    return this.inputType === 'text'
  }

  private togglePasswordVisibility() {
    this.inputType = this.inputType === 'text' ? 'password' : 'text'
  }

  private fetchLocation() {
    http.get('/auth/location').then((response: any) => {
      const disk = response.data.disk

      if (disk) {
        this.disk = disk
      }
    })
  }

  mounted() {
    this.fetchLocation()
  }
}

export default new Application(AuthRegister)
